import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import { Button } from 'react-bootstrap';
import { Card } from 'react-bootstrap';

// Dummy function for chart display
const StockChart = ({ symbol }) => {
  // You can replace this with your actual charting component or library
  return <div>{`Chart for ${symbol}`}</div>;
};

const StockList = ({ stocks, selectedStock, favorites, toggleFavorite, setSelectedStock }) => {

  const handleStockSelect = (symbol) => {
    setSelectedStock(symbol); // This should trigger an update in parent component if needed
  };

  const columns = [
    {
      name: 'Symbol',
      selector: (row) => row.symbol,
      sortable: true,
    },
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: 'Price',
      selector: (row) => `$${row.price.toFixed(2)}`,
      sortable: true,
    },
    {
      name: 'Change %',
      selector: (row) => `${row.changePercent.toFixed(2)}%`,
      sortable: true,
    },
    {
      name: 'Volume',
      selector: (row) => row.volume.toLocaleString(),
      sortable: true,
    },
    {
      name: 'Market Cap',
      selector: (row) => `$${row.marketCap.toLocaleString()}`,
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (row) => (
        <>
          {favorites.includes(row.symbol) ? (
            <i
              className="fa fa-star text-success"
              onClick={() => toggleFavorite(row.symbol)}
            ></i>
          ) : (
            <i
              className="fa fa-star"
              onClick={() => toggleFavorite(row.symbol)}
            ></i>
          )}
        </>
      ),
    },
  ];

  // Filter stock data for the selected stock
  const selectedStockData = stocks.find((stock) => stock.symbol === selectedStock);

  return (
    <>
      <Card className="my-4">
        <Card.Header className="border-bottom">
          <h2 className="m-0 h5">
            Stock Information
            {favorites.includes(selectedStock) ? (
              <i
                className="fa fa-star ms-2 text-success"
                onClick={() => toggleFavorite(selectedStock)}
                style={{ cursor: 'pointer'}}
              ></i>
            ) : (
              <i
                className="fa fa-star ms-2"
                onClick={() => toggleFavorite(selectedStock)}
                style={{ cursor: 'pointer'}}
              ></i>
            )}
          </h2>
        </Card.Header>
        <Card.Body>
          {/* Display chart and stock data for the selected stock */}
          <div>
            <StockChart symbol={selectedStock} />
            <div>
              <h5>{selectedStockData?.name}</h5>
              <p>{`Price: $${selectedStockData?.price.toFixed(2) ?? '--'}`}</p>
              <p>{`Change: ${selectedStockData?.changePercent.toFixed(2) ?? '--'}%`}</p>
              <p>{`Volume: ${selectedStockData?.volume.toLocaleString() ?? '--'}`}</p>
              <p>{`Market Cap: $${selectedStockData?.marketCap.toLocaleString() ?? '--'}`}</p>
            </div>
          </div>
        </Card.Body>
      </Card>

      <Card className="my-4">
        <Card.Header className="border-bottom">
          <h2 className="m-0 h5">Stock List</h2>
        </Card.Header>
        <Card.Body className="px-0 pt-0">
          <DataTable
            columns={columns}
            data={stocks}
            pagination
            highlightOnHover
            pointerOnHover
            onRowClicked={(row) => handleStockSelect(row.symbol)} // Update selected stock on row click
          />
        </Card.Body>
      </Card>
    </>
  );
};

export default StockList;
